import {isNumber, isEmpty} from 'lodash';

export const resources = {
  fieldIsRequired: 'This field is required.',
};

export const validators = {
  resources,
  positive(value) {
    if (value < 0) {
      return ['Requires a positive value'];
    }
    return true;
  },
  numeric(value, required) {
    if (typeof value != "string") {
      if (!isNumber(value)) {
        return ['Must be a number'];
      }
    }
    if (!isNaN(value) &&
      !isNaN(parseFloat(value))) {
      return true;
    }

    return ['Must be a number'];
  },
  selectRequired(value) {
    if (value && value.id > 0) {
      return true;
    }

    return ['Please select a value'];
  },
  selectRequiredUuid(value) {
    if (value && value.id) {
      return true;
    }

    return ['Please select a value'];
  },
  fileTypes(value) {

  },
  checkEmptyInput(value) {
    if (isEmpty(value.trim())) {
      return ["Input cannot be empty."]
    } else {
      return []
    }
  }
};

export const validateFileType = (filetypes) => (value) => {
  if (!value) {
    return;
  }

  const name = value.name;
  const hasExtension = (FileName, extensions) =>
      (new RegExp('(' + extensions.join('|').replace(/\./g, '\\.') + ')$')).test(FileName.toLowerCase())

  if (!hasExtension(name, filetypes)) {
    return 'File type must be any of the following: '+filetypes.join(', ');
  }

  return true;
}


export default validators;
